export default {
  name: "MessModal",
  props: {
    status: {
      type: Boolean,
      default: false
    },
    linkBackBtn: {
      type: String,
      default: ""
    },
    params: {
      type: Object,
      default: {}
    },
    typeMess: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      size: {
        success: 'sm',
        fails: 'md',
      },
      mess: {
        success: [
          "登録完了",
          "日誌を登録しました。"
        ],
        fails: [
          "登録失敗",
          "日誌の登録に失敗しました。\nもう一度試すか、管理者にご連絡ください。"
        ]
      }
    };
  },
  methods: {
    handleClickOk() {
      if (this.status) {
        const params = this.params;
        if (params) {
          this.$router.replace({
            path: "/", query:
            {
              siteId: params.siteId,
              period: params.period,
              objDate: params.objDate,
            }
          });
        }
      }
      this.$bvModal.hide('bv-modal-mess');
      this.$bvModal.hide('copy-diary-modal');
      if (this.typeMess == "messValidateFileUpload") {
        this.$emit('changeType', '');
      }
    }
  },
  computed: {
    sizeAndMess() {
      let conditionRender = this.status;
      let result = {size: "md", mess: ""}
      switch (this.typeMess) {
        case "confirmCopyDiary": {
          result.size = this.size.success;
          result.mess = conditionRender ? ["コピー完了", "日誌をコピーしました"] : ["コピー失敗", "日誌をコピーできませんでした"];
          break;
        }
        case "messValidateFileUpload":{
          result.size = this.size.fails;
          result.mess = ["登録失敗", "ファイル名に「# %  +  ? [ ]」を\n含むファイルは追加できません"];
          break;
        }
        default: {
          const stateRender = conditionRender ? "success" : "fails";
          result.size = this.size[stateRender];
          result.mess = this.mess[stateRender]
          break;
        }
      }
      return result;
    }
  }
}